import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cf07b53"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "modal-wrapper",
  class: "modal-wrapper"
}
const _hoisted_2 = { class: "modal-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "member-details" }
const _hoisted_6 = ["alt", "src"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "member-job-fields" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.open)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref: "modal-container",
            class: "modal-container",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (this.stopPropagation && this.stopPropagation(...args)))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("button", {
                  class: "modal-close",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.stopPropagation && this.stopPropagation(...args)))
                }, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    alt: _ctx.title,
                    src: _ctx.image.url
                  }, null, 8, _hoisted_6),
                  _createElementVNode("div", null, [
                    (_ctx.showName)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_7, _toDisplayString(_ctx.title), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("ul", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobFields, (field) => {
                        return (_openBlock(), _createElementBlock("li", { key: field }, _toDisplayString(field.job_field), 1))
                      }), 128))
                    ]),
                    (_ctx.showDetails)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.translate("Contact details")) + ":", 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("a", {
                              href: `tel:${_ctx.phone}`,
                              target: "_blank"
                            }, _toDisplayString(_ctx.phone), 9, _hoisted_10)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("a", {
                              href: `mailto:${_ctx.email}`,
                              target: "_blank"
                            }, _toDisplayString(_ctx.email), 9, _hoisted_11)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.fieldsOfActivity.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.translate("Fields of activity")) + ":", 1),
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldsOfActivity, (field) => {
                          return (_openBlock(), _createElementBlock("li", { key: field }, _toDisplayString(field.name), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 512)
          ], 512))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}